import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "../modal.css";
import { popupEventEmitter, hideBlockedPopup } from "../../../utils/popupHandler";
import { useNavigate } from "react-router-dom";

const BlockedPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();	

  const handleSubmit = () => {
    hideBlockedPopup();
    navigate("/login");
  }

  useEffect(() => {
    const show = () => setIsVisible(true);
    const hide = () => setIsVisible(false);

    popupEventEmitter.on("show", show);
    popupEventEmitter.on("hide", hide);

    return () => {
      popupEventEmitter.off("show", show);
      popupEventEmitter.off("hide", hide);
    };
  }, []);

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <>
      <div className="custom-modal-backdrop" onClick={hideBlockedPopup}></div>
      <div className="custom-modal w-[40%]">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">Access Denied</h5>
            <button className="custom-close-btn" onClick={hideBlockedPopup}>
              &times;
            </button>
          </div>
          <div className="custom-modal-body text-center p-4">
            <p className="text-lg text-red-600 font-semibold">
            You are blocked. Please contact your admin.
            </p>
          </div>
          <div className="custom-modal-footer flex justify-center gap-4 p-4">
            <button className="inline-flex w-full justify-center rounded-md bg-emerald-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-emerald-500 sm:ml-3 sm:w-auto" onClick={handleSubmit}>
              OK
            </button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("popup-root")
  );
};

export default BlockedPopup;
